//
//
//
//
//
//

export default {
  name: "App",
  computed: {
    keepAlive () {
      return this.$store.getters.keepAlive;
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue